<template>
  <div class="container">
    <tickets-manager-template />
  </div>
</template>

<script>
import TicketsManagerTemplate from "../components/templates/TicketsManagerTemplate.vue";

export default {
  components: {
    TicketsManagerTemplate,
  },
};
</script>

<style lang="sass" scoped>
.container
  padding: 12px 20px
  overflow-y: hidden
</style>
<style>
.ant-tooltip .ant-tooltip-content,
.ant-tooltip .ant-tooltip-content .ant-tooltip-inner {
  width: fit-content;
}
</style>
